import React from 'react';
import MarketingLayout from '../components/marketing/MarketingLayout';
import PageHero from '../components/marketing/PageHero';
import { IMAGES } from '../lib/marketingImages';
import { CONTACT_EMAIL } from '../config';

export default function PrivacyPage() {
  return (
    <MarketingLayout>
      <PageHero image={IMAGES.kitchen} eyebrow="Legal" title="Privacy policy" subtitle="How we look after the details you share with us." />
      <article className="prose prose-neutral dark:prose-invert max-w-3xl mx-auto px-4 py-16 space-y-6 text-muted-foreground">
        <p>SmartPay Utilities collects only what we need to pay your bills: your name, contact details, saved meters, and payment records.</p>
        <p>We do not sell your data. Pins and session tokens are stored securely. Payment processing is handled by PayChangu.</p>
        <p>You can ask us to update or delete account information by writing to <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.</p>
        <p>Last updated August 2026.</p>
      </article>
    </MarketingLayout>
  );
}
